import { deserialize, deserializeAs, inheritSerialization, SerializableEnumeration } from 'cerialize';
import { Entity } from './entity';
import { DocumentType } from './documentType';

SerializableEnumeration(DocumentType);

@inheritSerialization(Entity)
export class Document extends Entity {

  @deserialize
  logementId = null;

  @deserialize
  parentId = null;

  @deserialize
  nom = '';

  @deserialize
  picto = '';

  @deserializeAs(DocumentType)
  documentType: DocumentType;

  url: string;

  section: string = null;

  public static OnDeserialized(instance: Document, json: any): void {
    if (json.fichier && json.fichier.url) {
      instance.url = json.fichier.url;
    }

    if (json.nom_document_obligatoire) {
      instance.section = json.nom_document_obligatoire;
    }

    const arrayImageType = ['jpg', 'jpeg', 'png', 'gif'];
    const extension = instance.nom.split('.').pop();
    let picto: string;
    if (arrayImageType.indexOf(extension) != -1) {
      picto = 'image';
    } else {
      picto = 'fichier';
    }

    instance.picto = 'picto-' + picto + '.svg';


  }

}
